import { Link, useLocation } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const location = useLocation();

  return (
    <nav aria-label="面包屑导航" className="flex items-center text-sm text-foreground-600">
      <ol className="flex items-center flex-wrap gap-1">
        <li>
          <Link to="/" className="hover:text-primary-500 transition-colors whitespace-nowrap">
            <i className="ri-home-4-line"></i>
            <span className="ml-1">首页</span>
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1">
            <i className="ri-arrow-right-s-line text-xs"></i>
            {item.href ? (
              <Link to={item.href} className="hover:text-primary-500 transition-colors whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-950 font-medium whitespace-nowrap">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}